import React from "react";
import { SvgIcon } from "@mui/material";
const ShareIcon = () => {
  return (
    <SvgIcon>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1021 0.0414415C11.3637 -0.0553504 11.658 0.0210169 11.8395 0.232836L19.8395 9.56612C20.0535 9.81577 20.0535 10.1842 19.8395 10.4338L11.8395 19.7671C11.658 19.9789 11.3637 20.0553 11.1021 19.9585C10.8404 19.8617 10.6667 19.6122 10.6667 19.3333L10.6667 13.3454C8.97742 13.4083 7.3773 13.7271 5.89523 14.5324C4.22509 15.4399 2.64408 16.9984 1.25709 19.6429C1.10854 19.9261 0.779777 20.064 0.473652 19.9714C0.167527 19.8787 -0.0296969 19.5818 0.0036683 19.2637C0.253401 16.8829 1.2318 13.7691 3.05345 11.2332C4.77275 8.83982 7.28405 6.91364 10.6667 6.68863L10.6667 0.666695C10.6667 0.387712 10.8404 0.138233 11.1021 0.0414415ZM12 2.46886L12 7.33332C12 7.70151 11.7015 7.99999 11.3333 7.99999C8.1625 7.99999 5.79655 9.69998 4.13634 12.0111C3.26411 13.2254 2.59951 14.5933 2.13108 15.9342C3.10155 14.8008 4.1487 13.9639 5.25866 13.3608C7.19832 12.3069 9.26912 12 11.3333 12C11.7015 12 12 12.2984 12 12.6666L12 17.5311L18.4553 9.99997L12 2.46886Z"
      />
    </SvgIcon>
  );
};

export default ShareIcon;
